// @flow

export default Object.freeze({
  GET_COUPONS: 'GET_COUPONS',
  GET_COUPONS_ERROR: 'GET_COUPONS_ERROR',
  GET_COUPONS_START: 'GET_COUPONS_START',
  GET_COUPONS_SUCCESS: 'GET_COUPONS_SUCCESS',
  GET_COUPONS_RESET: 'GET_COUPONS_RESET',
  GET_DEALS: 'GET_DEALS',
  GET_DEALS_ERROR: 'GET_DEALS_ERROR',
  GET_DEALS_START: 'GET_DEALS_START',
  GET_DEALS_SUCCESS: 'GET_DEALS_SUCCESS',
  GET_DEALS_RESET: 'GET_DEALS_RESET',
});



// WEBPACK FOOTER //
// ./src/modules/store/common/dealsActionKeys.js